import * as applicationActions from "app/application/actions";
import * as externalActions from "external/container/actions";
import { notifier } from "common/notifier";
import * as appRouting from "appRouting";
//-- Reponses
export var ResponseStatus;
(function (ResponseStatus) {
    ResponseStatus[ResponseStatus["ok"] = 200] = "ok";
    ResponseStatus[ResponseStatus["noContent"] = 204] = "noContent";
    ResponseStatus[ResponseStatus["badRequest"] = 400] = "badRequest";
    ResponseStatus[ResponseStatus["notAuthenticated"] = 401] = "notAuthenticated";
    ResponseStatus[ResponseStatus["notAuthorised"] = 403] = "notAuthorised";
    ResponseStatus[ResponseStatus["serverError"] = 500] = "serverError";
    ResponseStatus[ResponseStatus["unknown"] = 0] = "unknown";
})(ResponseStatus || (ResponseStatus = {}));
export class ResponseError {
    constructor(status, message) {
        this.status = status;
        this.message = message;
    }
}
//-- GET Json at a PAGE level -------------------------------------------------------------------------------------------------------------------------------
export function getPageJson(dispatch, url) {
    return fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
            "Accept": "application/json",
            //Fix for ie 11 using the cache for getting the users data
            "Cache-Control": "no-store",
            "Pragma": "no-cache"
        }
    })
        .then((response) => {
        if (response.ok) {
            if (response.status == 204) {
                console.log("postComponentJson - 204", response.statusText);
                dispatch(applicationActions.createAction_PageUnderMaintenance(true, response.statusText));
                let responseError = new ResponseError(ResponseStatus.noContent, response.statusText);
                return Promise.reject(responseError);
            }
            else {
                // All is okay - show page
                dispatch(applicationActions.createAction_ShowPage());
                return Promise.resolve(response);
            }
        }
        else {
            // 400 - bad request
            if (response.status === 400) {
                console.log("getPageJson - 400", response.statusText);
                let responseError = new ResponseError(ResponseStatus.badRequest, response.statusText);
                return Promise.reject(responseError);
            }
            if (response.status === 401 || response.status === 410) {
                console.log("getPageJson - 401/410", response.statusText);
                // Dispatch action that user is not authenticated
                dispatch(applicationActions.createAction_PageAuthentication(false));
                // Redirect to log in
                appRouting.loginNavigate(dispatch);
                let responseError = new ResponseError(ResponseStatus.notAuthenticated, response.statusText);
                return Promise.reject(responseError);
            }
            if (response.status === 403) {
                console.log("getPageJson - 403", response.statusText);
                // show not authorised screen
                dispatch(applicationActions.createAction_PageAuthorisation(false));
                let responseError = new ResponseError(ResponseStatus.notAuthorised, response.statusText);
                return Promise.reject(responseError);
            }
            // show server error screen
            console.log("getPageJson - error (unknown code)", response.statusText);
            dispatch(applicationActions.createAction_PageError(true));
            let responseError = new ResponseError(ResponseStatus.serverError, response.statusText);
            return Promise.reject(responseError);
        }
    }, (error) => {
        // show server error screen
        console.log("getPageJson - error", error);
        dispatch(applicationActions.createAction_PageError(true));
        let responseError = new ResponseError(ResponseStatus.unknown, error);
        return Promise.reject(responseError);
    });
}
//-- GET Json at a COMPONENT level -------------------------------------------------------------------------------------------------------------------------------
export function getComponentJson(dispatch, url) {
    let headers = null;
    if (feedMode) {
        headers = {
            "pp-agentdesk-feedapikey": feedapikey,
            "pp-agentdesk-feedtoken": feedToken
        };
    }
    else {
        headers = {
            "Accept": "application/json"
        };
    }
    return fetch(url, {
        method: "GET",
        credentials: "include",
        headers: headers
    })
        .then((response) => {
        if (response.ok) {
            if (response.status == 204) {
                console.log("postComponentJson - 204", response.statusText);
                if (feedMode) {
                    dispatch(externalActions.createAction_ExternalUnderMaintenance(true, response.statusText));
                }
                else {
                    dispatch(applicationActions.createAction_PageUnderMaintenance(true, response.statusText));
                }
                let responseError = new ResponseError(ResponseStatus.noContent, response.statusText);
                return Promise.reject(responseError);
            }
            else {
                // 200 - Ok
                return Promise.resolve(response);
            }
        }
        else {
            // 400 - bad request
            if (response.status === 400) {
                console.log("getComponentJson - 400", response.statusText);
                if (feedMode) {
                    dispatch(externalActions.createAction_ExternalError(true));
                }
                let responseError = new ResponseError(ResponseStatus.badRequest, response.statusText);
                return Promise.reject(responseError);
            }
            // 401 - not authenticated
            if (response.status === 401) {
                console.log("getComponentJson - 401", response.statusText);
                // Redirect to log in
                if (feedMode) {
                    if (response.statusText == "Timed Out") {
                        dispatch(externalActions.createAction_ExternalTokenTimeValid(false));
                    }
                    else {
                        dispatch(externalActions.createAction_ExternalAuthentication(false));
                    }
                }
                else {
                    // Dispatch action that user is not authenticated
                    dispatch(applicationActions.createAction_PageAuthentication(false));
                    appRouting.loginNavigate(dispatch);
                }
                let responseError = new ResponseError(ResponseStatus.notAuthenticated, response.statusText);
                return Promise.reject(responseError);
            }
            // 403 - not authorised
            if (response.status === 403) {
                console.log("getComponentJson - 403", response.statusText);
                // show not authorised screen
                if (feedMode) {
                    dispatch(externalActions.createAction_ExternalAuthorisation(false));
                }
                else {
                    dispatch(applicationActions.createAction_PageAuthorisation(false));
                }
                let responseError = new ResponseError(ResponseStatus.notAuthorised, response.statusText);
                return Promise.reject(responseError);
            }
            // ??? - some other error code
            console.log("getComponentJson - error (unknown code)", response.statusText);
            if (feedMode) {
                dispatch(externalActions.createAction_ExternalError(true));
            }
            let responseError = new ResponseError(ResponseStatus.serverError, response.statusText);
            return Promise.reject(responseError);
        }
    }, (error) => {
        // Any error caught
        console.log("getComponentJson - error", error);
        if (feedMode) {
            dispatch(externalActions.createAction_ExternalError(true));
        }
        let responseError = new ResponseError(ResponseStatus.unknown, "Error fetching data");
        return Promise.reject(responseError);
    });
}
//-- POST Json at a COMPONENT level -------------------------------------------------------------------------------------------------------------------------------
export const postComponentJson = (dispatch, url, data) => {
    return postComponentJson_local(dispatch, true, url, data);
};
export const postAuthComponentJson = (dispatch, url, data) => {
    return postComponentJson_local(dispatch, false, url, data);
};
const postComponentJson_local = (dispatch, considerUnderMaintenance, url, data) => {
    return fetch(url, {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify(data)
    }).then((response) => {
        if (response.ok) {
            if (response.status == 204) {
                console.log("postComponentJson - 204", response.statusText);
                dispatch(applicationActions.createAction_PageUnderMaintenance(true, response.statusText));
                let responseError = new ResponseError(ResponseStatus.noContent, response.statusText);
                return Promise.reject(responseError);
            }
            else {
                // 200 - Ok
                return Promise.resolve(response);
            }
        }
        else {
            // 400 - bad request
            if (response.status === 400) {
                console.log("postComponentJson - 400", response.statusText);
                let responseError = new ResponseError(ResponseStatus.badRequest, response.statusText);
                return Promise.reject(responseError);
            }
            // 401 - not authenticated
            if (response.status === 401) {
                console.log("postComponentJson - 401", response.statusText);
                // Dispatch action that user is not authenticated
                dispatch(applicationActions.createAction_PageAuthentication(false));
                // Redirect to log in
                appRouting.loginNavigate(dispatch);
                let responseError = new ResponseError(ResponseStatus.notAuthenticated, response.statusText);
                return Promise.reject(responseError);
            }
            // 403 - not authorised
            if (response.status === 403) {
                console.log("postComponentJson - 403", response.statusText);
                notifier.notifyError("Error Submitting", response.statusText);
                let responseError = new ResponseError(ResponseStatus.notAuthorised, response.statusText);
                return Promise.reject(responseError);
            }
            // ??? - some other error code
            console.log("postComponentJson - error (unknown code)", response.statusText);
            let responseError = new ResponseError(ResponseStatus.serverError, response.statusText);
            return Promise.reject(responseError);
        }
    }, (error) => {
        console.log("postComponentJson - error", error);
        // Any error caught
        let responseError = new ResponseError(ResponseStatus.unknown, error.message);
        return Promise.reject(responseError);
    });
};
//---------------------------------------------------------------------------------------------------------------------------------
